import { render, staticRenderFns } from "./MenuConfigManagement.vue?vue&type=template&id=633df0e2&scoped=true"
import script from "./MenuConfigManagement.vue?vue&type=script&lang=js"
export * from "./MenuConfigManagement.vue?vue&type=script&lang=js"
import style0 from "./MenuConfigManagement.vue?vue&type=style&index=0&id=633df0e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633df0e2",
  null
  
)

export default component.exports